import React from "react";
import { Badge, Card, Col, ListGroup, Row } from "react-bootstrap";
import { FaWallet } from "react-icons/fa";
import { MdCalendarToday } from "react-icons/md";
import { useTranslation } from "react-i18next"; // Import useTranslation

import PieChart from "../StatsChart/PieChart";

const DayView = ({ date, expensesItems }) => {
  const { t } = useTranslation(); // Initialize useTranslation hook
  const formattedDate = date.toISOString().split("T")[0];
  const itemsForDay = expensesItems.filter((item) => item.purchasedDate === formattedDate);
  const totalAmount = itemsForDay.reduce((total, item) => total + Number(item.total || 0), 0);

  return (
    <Card className="shadow-sm border-0" style={{ borderRadius: "15px" }}>
      <Card.Body className="p-4">
        <div className="d-flex align-items-center gap-3 mb-4">
          <MdCalendarToday size={28} className="text-primary" />
          <div>
            <h3 className="mb-0">
              {date.toLocaleDateString("en-US", { weekday: "long", year: "numeric", month: "long", day: "numeric" })}
            </h3>
            <Badge bg="light" text="dark" className="mt-1">
              {t("statistics.dayViewComp.dailySummary")}
            </Badge>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mb-4 p-3 bg-light rounded-3">
          <div>
            <h5 className="mb-0">{t("statistics.dayViewComp.totalSpent")}</h5>
            <small className="text-muted">{t("statistics.dayViewComp.dailyBudgetProgress")}</small>
          </div>
          <h2 className="mb-0 text-primary">${totalAmount.toFixed(2)}</h2>
        </div>

        {itemsForDay.length > 0 ? (
          <>
            <ListGroup variant="flush" className="mb-4">
              {itemsForDay.map((item, index) => (
                <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center py-3">
                  <div>
                    <h6 className="mb-0">{item.category}</h6>
                    <small className="text-muted">{item.title}</small>
                  </div>
                  <Badge bg="light" text="dark" className="fs-6">
                    ${item.total}
                  </Badge>
                </ListGroup.Item>
              ))}
            </ListGroup>

            <Row className="g-4">
              <Col xs={12} lg={6}>
                <div className="p-3 bg-light rounded-3">
                  <h5 className="mb-3">{t("statistics.dayViewComp.spendingDistribution")}</h5>
                  <PieChart items={itemsForDay} />
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <div className="text-center py-5">
            <FaWallet size={48} className="text-muted mb-3" />
            <h5 className="text-muted">{t("statistics.dayViewComp.noExpenses")}</h5>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default DayView;
